import { render, staticRenderFns } from "./FormLayoutMenu.vue?vue&type=template&id=78bea8ea&scoped=true"
import script from "./FormLayoutMenu.vue?vue&type=script&lang=js"
export * from "./FormLayoutMenu.vue?vue&type=script&lang=js"
import style0 from "./FormLayoutMenu.vue?vue&type=style&index=0&id=78bea8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bea8ea",
  null
  
)

export default component.exports